import { render, staticRenderFns } from "./DeliverectSettings.vue?vue&type=template&id=420416fc"
import script from "./DeliverectSettings.vue?vue&type=script&lang=js"
export * from "./DeliverectSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports